const envConfig = {
  ApiUrl: import.meta.env.VITE_API_URL || '',
  ApiKey: import.meta.env.VITE_API_KEY || '',
  StoragePrefix: import.meta.env.VITE_PREFIX || '',
  DefaultLanguage: import.meta.env.VITE_DEFAULT_LANGUAGE || '',
  ContactEmail: import.meta.env.VITE_CONTACT_EMAIL || '',
  SupportEmail: import.meta.env.VITE_SUPPORT_EMAIL || '',
  SiteTitle: import.meta.env.VITE_TITLE || '',
  SiteDescription: import.meta.env.VITE_DESCRIPTION || '',
  TokenLifetimeHours: import.meta.env.VITE_TOKEN_LIFETIME_HOURS || '24',
  EncryptionKey: import.meta.env.VITE_ENCRYPTION_KEY || '',
  ServerConfigurationString: import.meta.env.VITE_SERVER_CONFIG_STRING || '',
  HideMenuLocations: ['/register', '/recover', '/reset', '/updatepass'],
  HideHeaderLogo: ['/', '/register', '/recover', '/reset', '/updatepass'],
  Roles: [
    { index: 1, key: 'GlobalAdmin', name: 'global_admin' },
    { index: 2, key: 'Admin', name: 'admin' },
    { index: 3, key: 'CustomerSupport', name: 'customer_support' },
    { index: 4, key: 'OperatorAdmin', name: 'operator_admin' },
    { index: 5, key: 'Finance', name: 'finance' },
    { index: 6, key: 'Analytics', name: 'analytics' },
    { index: 7, key: 'LimitedFinance', name: 'limited_finance' },
    { index: 8, key: 'LimitedAnalytics', name: 'limited_analytics' },
    { index: 9, key: 'DataWarehouseHealth', name: 'data_warehouse_health' }
  ]
};

export default envConfig;
